import script from "./recruitDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./recruitDetail.vue?vue&type=script&lang=ts&setup=true"

import "./recruitDetail.vue?vue&type=style&index=0&id=0cb5f0ac&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cb5f0ac"]])

export default __exports__